/**
 * Admin Settings sidebar configuration
 */
export default {
  pathPrefix: 'admin/settings',
  items: [
    {
      label: 'Onboarding',
      href: '/admin/settings/onboarding_flows',
      icon: 'fa-solid fa-clipboard-question',
      activePath: 'admin/settings/onboarding_flows'
    },
    {
      label: 'Operations',
      href: '/admin/settings/operation_states',
      icon: 'fa-solid fa-gears',
      activePath: 'admin/settings/operation_states'
    }
  ]
}
